import { render } from "./SiteCredit.vue?vue&type=template&id=36a684eb&scoped=true"
import script from "./SiteCredit.vue?vue&type=script&lang=js"
export * from "./SiteCredit.vue?vue&type=script&lang=js"

import "./SiteCredit.vue?vue&type=style&index=0&id=36a684eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a684eb"]])

export default __exports__